
SJ.MainClass =
class extends SJ.EventHandler {
  init() {

    this.createEvent('restart');

    this._drawableObjects = [];

    this._engine = Matter.Engine.create();
    SJ.world = this._engine.world;
    // SJ.world.gravity.y = SJ.V.gravity;

    this._createScoreCounter();
    this._createAirSystem();

    this._prepareScreenLayer();

    SJ.itemsManager.resetActiveItems();
    this.addEventListener('restart', () => {
      SJ.itemsManager.resetActiveItems();
    });

    SJ.pad = new SJ.LaunchingPad();
    this.addEventListener('restart', () => {
      SJ.pad.restart();
    });

    this._createJumper();

    SJ.camera = new SJ.Camera(SJ.V.cameraScale);
    this.addEventListener('restart', () => {
      SJ.camera.restart();
    });

    SJ.paralaxBackground = new SJ.ParalaxBackground();

    SJ.movingObjects = new SJ.MovingObjects();

    SJ.weather = new SJ.WeatherManagement();

    this._fillDrawableObjectsArray();

    SJ.PadCreator.loadImages();
    SJ.pad.loadImages();

    SJ.pad.onReady();

    // Matter.Engine.run(this._engine);

    this._isRunning = true;
    this._wantShowJumpEndPopup = false;

    if(flyMode) {
      const texture = SJ.ImageLoader.load("TitanBase/Pad/white_light.png");
      SJ.fly = new Light(0, 0, texture)
    }

    //Setup player collision detect
    Matter.Events.on(this._engine, 'collisionStart', () => {
      SJ.jumper.padHit = true;
    })

    // this._printNewJumpHeader();
    this.updatesRatio = 2;
    this.curUpdates = 0;

    // window.setInterval(() => this._update(), 16);

    // this.addEventListener('restart', () => {
      // SJ.playerData.incrementDailyJumpsCount();
      // SJ.userDataBar.updateDisplayData();
    // });
  }

  destruct(){
    SJ.paralaxBackground = null;
    SJ.weather = null;
    SJ.pad = null;
    SJ.camera = null;
    SJ.movingObjects = null;
    SJ.jumper = null;
    SJ.scoreCounter = null;
    SJ.airSystem = null;

    console.log('GAME OVER');
  }

  _printNewJumpHeader(){
    let d = new Date();
    let time = `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;

    console.log('');
    console.log(`%c -----NEW JUMP ${time}-----`, "color: orange");
  }

  _prepareScreenLayer() {
    this.screenLayer = [];
    SJ.V.screenLayer.forEach(data => {
      if(data.type === "particlesystem") {
        if(data.system === "wind") {
          this.screenLayer.push(new SJ.WindParticleSystem());
        }
      }
    })
  }

  setRunning(flag) {
    this._isRunning = flag;

    if(flag) {
      SJ.jumper.body.isStatic = SJ.jumper.realBodyStatic;

      if(this._wantShowJumpEndPopup) {
        this._wantShowJumpEndPopup = false;
        this._showJumpEndPopup();
      }
    }else {
      SJ.jumper.realBodyStatic = SJ.jumper.body.isStatic;
      SJ.jumper.body.isStatic = true;
    }
  }

  _createJumper() {
    SJ.jumper = new SJ.Jumper(SJ.V.jumperPosition.x, SJ.V.jumperPosition.y);
    this.addEventListener('restart', () => {
      SJ.jumper.reset();
    })
  }

  _createScoreCounter() {
    SJ.scoreCounter = new SJ.ScoreCounter();
  }

  _createAirSystem() {
    SJ.airSystem = new SJ.AirSystem();

    if(SJ.airSystem.airForce <= 4)
      SJ.weatherSoundContainer.play('slowWind');
    else
      SJ.weatherSoundContainer.play('fastWind');
  }

  _fillDrawableObjectsArray() {
    this._drawableObjects = [];
    this.appendDrawable(SJ.pad);
    this.appendDrawable(SJ.jumper);
  }

  appendDrawable(drawable) {
    this._drawableObjects.push(drawable);
  }

  draw() {

    this._update();

    background(57, 66, 95);

    push();
      SJ.paralaxBackground.draw();

      SJ.camera.transform();
      this._drawableObjects.forEach((element) => {
        element.draw();
      });

      SJ.pad.drawFront();

      // SJ.camera.drawPath();
    pop();

    SJ.ControlJoystick.draw();

    this._drawScrenLayer();

    SJ.weather.draw();
  }

  _update() {
    if(!this._isRunning && SJ.LoadingScreen.remainingToLoad >= 1)
      return;

    Matter.Engine.update(this._engine);
    SJ.jumper.update();
    SJ.pad.update();
    SJ.camera.update();
    SJ.airSystem.update();
    SJ.weather.update();
  }

  _drawScrenLayer() {
    this.screenLayer.forEach(element => {
      element.draw();
    })
  }

  _restartGame() {
    this._printNewJumpHeader();

    this._wantShowJumpEndPopup = false;

    SJ.itemsManager.deactivateAllItemsRunOfLuck();

    SJ.higherJumperSpeed = 0.0;
    SJ.higherJumperHeight = 0.0;

    SJ.scoreCounter.restart();

    this.setRunning(true);

    this._createScoreCounter();
    this._createAirSystem();

    SJ.pad.onReady();

    SJ.weather.resetParticlesPosition();

    SJ.jumpScoreDisplay.hide();
    SJ.jumpParamDisplay.hide();
    SJ.medalDisplay.hide();
    SJ.newRankDisplay.hide();
    SJ.mapRecordDisplay.hide();
    SJ.coachDisplay.hide();

    SJ.crowdSoundContainer.stop(null, true);

    if(SJ.playerData.data['name'] === 'Guest')
      SJ.registerDisplay.show();

    SJ.steeringInfoDisplay.ifIsFirstJump();

    this.callEvent('restart');
    SJ.slidersManager.update();

  }

  onJumperPadHit() {

    SJ.pad.startPullingJumper();

    if(SJ.V.mapType === 'ski'){
      SJ.scoreCounter.calculateDistance();
      SJ.scoreCounter.calculateScore();
    }else{
      this._showJumpEndPopup();
    }

    if(!this._isRunning) {
      this._wantShowJumpEndPopup = true;
    }
  }

  _showJumpEndPopup() {

    window.setTimeout(() => {

      if(SJ.V.mapType === 'ski'){
        SJ.jumperSoundContainer.play('score');

        SJ.scoreCounter.showJumpScoreDisplay();
        SJ.scoreCounter.showJumpParamDisplay();
        SJ.scoreCounter.showMedalDisplay();
        SJ.scoreCounter.showNewRankDisplay();
        SJ.scoreCounter.showMapDistanceRecordDisplay();
        SJ.scoreCounter.showCoachDisplay();

        SJ.userDataBar.updateDisplayData();
        SJ.playerData.updatePlayerRankPosition(SJ.userDataBar.updateDisplayData());

        SJ.jumperSoundContainer.stop('landing');
      }
    }, 3500);
  }

};
